import { app } from "../serviceLMS";
import { GET_SINGLE_GROUP_REPORT, DOWNLOAD_GROUP_SINGLE_REPORT } from "../URLs";
import { downloadExcelFile } from "../../assets/commonFunctions/CommonFunction";

export async function fetchAdminGroupReport(params) {
  try {
    const response = await app.get("user/api/client-api/reports/kpi/groups", {params});
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching enrollments",
    };
  }
}

export const downloadGroupReport = async (params) => {
  try {
    const response = await app.get(
      "user/api/client-api/reports/kpi/groups/download",
      {
        params,
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", "group_kpi_report.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Download failed",
    };
  }
};

export const getSingleGroupReport = async (groupId, params = {}) => {
  try {
    const response = await app.get(
      `${GET_SINGLE_GROUP_REPORT}${groupId}`,
      {
        params: {
          page:     params.page     ?? 0,
          size:     params.size     ?? 10,
          sortDir:  params.sortDir  || "DESC",
          search:   params.search   || undefined,
          subType:  params.subType  || undefined,
          status:   params.status   || undefined,
          courseId: params.courseId || undefined,
          bundleId: params.bundleId || undefined,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getGroupReportFilterOptions = async (groupId) => {
  try {
    const response = await app.get(
      `${GET_SINGLE_GROUP_REPORT}${groupId}/filter-options`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const downloadSingleGroupReport = async (groupId) => {
  try {
    const response = await app.get(
      `${DOWNLOAD_GROUP_SINGLE_REPORT}${groupId}/download`,
      {
        responseType: 'blob',
      }
    );
    downloadExcelFile(response?.data, "Group KPI Report");
    return { success: true, data: "KPI Report downloaded successfully." }
  } catch (error) {
    console.error("Error downloading user KPI report:", error);
    throw error;
  }
};
